<template>

  <!-- Backdrop / Fond de la modale, affiché seulement si openModal est true -->
  <div
    class="modal"
    @click.self="closeModal"
  >
    <!-- Contenu de la modale -->
    <div class="modal-content">
      <div class="form-group">
        <label class="form-label">
          <span v-if="firstPerson">Mon prénom</span>
          <span v-else>
            Son prénom
          </span>
        </label>

        <input
          class="form-input"
          v-model="form.name">
      </div>

      <div class="form-group">
        <label class="form-label">
          <span v-if="firstPerson">Mon année de naissance</span>
          <span v-else>
            Son année de naissance
          </span>
        </label>

        <input
          class="form-input"
          type="number"
          min="1900"
          max="2900"
          v-model="form.year_of_birth">
      </div>

      <div class="form-group">
        <label class="form-label">
          <span v-if="firstPerson">Mon genre</span>
          <span v-else>
            Son genre
          </span>
        </label>

        <select
          class="form-input"
          v-model="form.gender">
          <option value="male">
            Homme
          </option>
          <option value="female">
            Femme
          </option>
        </select>
      </div>

      <div class="form-group">
        <label class="form-label">
          <span v-if="firstPerson">Je souhaite perdre du poids</span>
          <span v-else>
            Il/Elle souhaite perdre du poids
          </span>
        </label>

        <select
          class="form-input"
          v-model="form.want_to_loose_weight">
          <option :value="false">
            Non
          </option>
          <option :value="true">
            Oui
          </option>
        </select>
      </div>

      <div class="form-group">
        <label class="form-label">
          <span v-if="firstPerson">Ma taille en cm</span>
          <span v-else>
            Sa taille en cm
          </span>
        </label>

        <input
          class="form-input"
          type="number"
          min="0"
          v-model="form.height">
      </div>

      <div class="form-group">
        <label class="form-label">
          <span v-if="firstPerson">Mon poids en kg</span>
          <span v-else>
            Son poids en kg
          </span>
        </label>

        <input
          class="form-input"
          type="number"
          min="0"
          v-model="form.weight">
      </div>

      <div class="form-group">
        <label class="form-label">
          Temps d'activité physique moyenne par jour
          <a href="#" class="infos" v-b-popover.hover.top="`Connaitre votre temps moyen d'activité physique par jour nous aide à calculer vos besoins en apport calorique`" title="Temps moyen d'activité physique par jour">?</a>
        </label>

        <!-- Compteur global 10h -->
        <div class="activity-counter" :class="counterClass">
          <div class="activity-counter__bar">
            <div class="activity-counter__fill" :style="{ width: Math.min(totalUsed / 600 * 100, 100) + '%', background: counterFillColor }"></div>
          </div>
          <div class="activity-counter__text">
            <span>Utilisé : <strong>{{ totalDisplay }}</strong></span>
            <span>Restant : <strong>{{ remainingDisplay }}</strong> / 10h max</span>
          </div>
          <div v-if="showCombinedWarning" class="activity-counter__warning">
            ⚠️ Le total dépasse 7h — vérifiez vos saisies.
          </div>
        </div>

        <div class="grid">
          <div>
            Faible intensité <span class="max-hint">(max 6h)</span>
            <a href="#" class="infos" v-b-popover.hover.top="`Exemple: Position debout, attente passive, cuisiner, travail statique...`" title="Temps moyen d'activité physique de faible intensité par jour">?</a>
          </div>

          <InteractiveProgressBar
            v-model="form.low_intensity_activity"
            :max="360"
            :clamp-to="maxLow"
            :height="25"
            :label="humanizeActivity(form.low_intensity_activity)"
            :step="5"
            color="#7ab228" />

          <div>
            Intensité modérée <span class="max-hint">(max 6h)</span>
            <a href="#" class="infos" v-b-popover.hover.top="`Exemple: Industrie de production, menuiserie, yoga, marche...`" title="Temps moyen d'activité physique d'intensité modérée par jour">?</a>
          </div>

          <InteractiveProgressBar
            v-model="form.medium_intensity_activity"
            :max="360"
            :clamp-to="maxMedium"
            :height="25"
            :label="humanizeActivity(form.medium_intensity_activity)"
            :step="5"
            color="#e7b642" />

          <div>
            Forte intensité <span class="max-hint">(max 6h)</span>
            <a href="#" class="infos" v-b-popover.hover.top="`Exemple: Travaux du bâtiment, bêchage, ménage intensif, sport en compétition, footing...`" title="Temps d'activité physique moyenne de forte intensité par jour">?</a>
          </div>

          <InteractiveProgressBar
            v-model="form.high_intensity_activity"
            :max="360"
            :clamp-to="maxHigh"
            :height="25"
            :label="humanizeActivity(form.high_intensity_activity)"
            :step="5"
            color="#ee5e5b" />
        </div>
      </div>
      
      <div style="display: flex; justify-content: flex-end; margin-top: 1rem; gap: 10px;">
        <button class="button" @click="closeModal">
          Fermer
        </button>

        <button class="button" @click="save">
          Sauvegarder
        </button>
      </div>
    </div>
  </div>
</template>

<script>

import InteractiveProgressBar from '@/components/InteractiveProgressBar.vue';
import { api } from "@/api";


export default {
  name: "EditActivityModal",
  components: {
    InteractiveProgressBar,
  },
  props: {
    profil: {
      type: Object,
      required: true,
    },
    firstPerson: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        name: this.profil.name,
        year_of_birth: this.profil.year_of_birth,
        low_intensity_activity: this.profil.low_intensity_activity,
        medium_intensity_activity: this.profil.medium_intensity_activity,
        high_intensity_activity:  this.profil.high_intensity_activity,
        gender: this.profil.gender,
        want_to_loose_weight: this.profil.want_to_loose_weight,
        height: this.profil.height,
        weight: this.profil.weight,
      },
      saving: false,
    };
  },
  computed: {
    totalUsed() {
      return (this.form.low_intensity_activity    || 0)
           + (this.form.medium_intensity_activity || 0)
           + (this.form.high_intensity_activity   || 0);
    },
    remaining() {
      return Math.max(0, 600 - this.totalUsed);
    },
    maxLow() {
      const free = 600 - (this.form.medium_intensity_activity || 0) - (this.form.high_intensity_activity || 0);
      return Math.max(0, Math.min(360, free));
    },
    maxMedium() {
      const free = 600 - (this.form.low_intensity_activity || 0) - (this.form.high_intensity_activity || 0);
      return Math.max(0, Math.min(360, free));
    },
    maxHigh() {
      const free = 600 - (this.form.low_intensity_activity || 0) - (this.form.medium_intensity_activity || 0);
      return Math.max(0, Math.min(360, free));
    },
    showCombinedWarning() {
      return this.totalUsed > 420;
    },
    counterClass() {
      if (this.totalUsed >= 600) return 'activity-counter--full';
      if (this.showCombinedWarning) return 'activity-counter--warn';
      return '';
    },
    counterFillColor() {
      if (this.totalUsed >= 600) return '#ee5e5b';
      if (this.showCombinedWarning) return '#e7b642';
      return '#7ab228';
    },
    totalDisplay() {
      const h = Math.floor(this.totalUsed / 60);
      const m = this.totalUsed % 60;
      return m === 0 ? `${h}h` : `${h}h ${m}min`;
    },
    remainingDisplay() {
      const h = Math.floor(this.remaining / 60);
      const m = this.remaining % 60;
      return m === 0 ? `${h}h` : `${h}h ${m}min`;
    },
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    humanizeActivity(time) {
      const hours = Math.floor(time / 60);
      const minutes = time % 60;
      return `${hours} heures ${minutes} minutes`;
    },
    save() {
      this.saving = true;

      if (this.profil.id) {
        api.patch(`/my-consumers/${this.profil.id}/`, this.form)
          .then((response) => {
            this.$emit('update', response.data);
            window.location.reload();
            this.closeModal();
          })
          .finally(() => {
            this.saving = false;
          });
      } else {
        api.post('/my-consumers/', this.form)
          .then((response) => {
            this.$emit('update', response.data);
            window.location.reload();
            this.closeModal();
          })
          .finally(() => {
            this.saving = false;
          }); 
      }
    }, 
  }
}
</script>

<style scoped>

.max-hint {
  font-size: 0.75rem;
  color: #888;
}

.activity-counter {
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 0.6rem 0.9rem;
  margin-bottom: 0.75rem;
  background: #f9f9f9;
}
.activity-counter--warn { border-color: #e7b642; background: #fffbf0; }
.activity-counter--full { border-color: #ee5e5b; background: #fff5f5; }

.activity-counter__bar {
  height: 8px;
  background: #ddd;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 0.4rem;
}
.activity-counter__fill {
  height: 100%;
  border-radius: 4px;
  transition: width 0.15s, background 0.15s;
}
.activity-counter__text {
  display: flex;
  justify-content: space-between;
  font-size: 0.82rem;
  color: #555;
}
.activity-counter__warning {
  margin-top: 0.4rem;
  font-size: 0.8rem;
  color: #b07d00;
  font-weight: 500;
}

.my-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.my-modal-container {
  background: #fff;
  padding: 2rem;
  border-radius: 8px;
  min-width: 300px;
  max-width: 500px;
}


.share-container {
  display: flex;
  justify-content: center;
  margin-top: 1rem;
}


.share-btn {
  margin-right: 1rem; /* simple marge */
  text-decoration: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  color: #fff;
}
.facebook {
  background: #3b5998;
}
.twitter {
  background: #1da1f2;
}
.linkedin {
  background: #0077B5;
}


.grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  grid-template-columns: 1fr 2fr;
  grid-template-rows: auto;
  grid-auto-flow: row;
}


</style>
